// extracted by mini-css-extract-plugin
export var isActive = "index-module--isActive--a1a2b";
export var isOpen = "index-module--isOpen--8e248";
export var link = "index-module--link--6204e";
export var linkArrow = "index-module--linkArrow--e8ea5";
export var linkTitle = "index-module--linkTitle--bd33b";
export var sublink = "index-module--sublink--1f851";
export var submenu = "index-module--submenu--1d66a";
export var submenuContent = "index-module--submenuContent--7c549";
export var submenuLinkIcon = "index-module--submenuLinkIcon--735d9";
export var submenuList = "index-module--submenuList--ebc84";
export var submenuSmall = "index-module--submenuSmall--7568c";